<!-- Standard login screen-->

<div class="fullscreen" [ngStyle]="{'background-color':'#000033', backgroundImage: 'url(' + service.V.config.host + '/4dinfo/bg.jpg)', backgroundRepeat: 'no-repeat',backgroundPosition: 'center center'}">


    <div class="d-flex justify-content-end h-100">
        <div class="flex-grow-1 d-flex flex-column justify-content-end">
            <div [ngStyle]="{'background-color':'#000000AA'}" class="d-flex justify-content-center">
                <h1 class="text-light m-3">{{ service?.vasatInstance?.greeting || 'Welcome'}}</h1>
            </div>
        </div>
        <div class="col-4 p-5 h-100 d-flex flex-column justify-content-center"  [ngStyle]="{'background-color':'white'}">

            <!-- Sign in logo -->
          
                <div class="d-flex justify-content-center">
                    <div  (click)="changeServer = changeServer?changeServer + 1 :1">
                        <img class="logo-img" src="{{service.V.config.host + '/4dinfo/image.png'}}">
                    </div>
                </div>

                <!-- Sign in to (app name) -->
                <div class="d-flex justify-content-center">
                    <ng-container *ngIf="service.vasatInstance">
                        <h3 class="text-center mt-4">{{ 'SIGNIN.TEXT' | translate: {siteName:service.vasatInstance.app_name} }}</h3>
                    </ng-container>
                    <ng-container *ngIf="!service.vasatInstance">
                        <h3 translate class="text-center mt-4">APP_NAME</h3>
                    </ng-container>
                </div>

                <div>
                    <!-- Sign in email address -->
                    <form #loginForm="ngForm" (ngSubmit)="login()">
                        <mat-form-field class="w-100">
                            <mat-icon matPrefix class="mr-2">email</mat-icon>
                            <input matInput #email="ngModel" type="text" name="username1" placeholder="{{'SIGNIN.EMAIL' | translate }}" [(ngModel)]="username" required >
                        </mat-form-field>

                        <!-- Sign in password -->
                        <mat-form-field class="w-100">
                            <mat-icon matPrefix class="mr-2">lock</mat-icon>
                            <input matInput #pass="ngModel" type="password" name="password1" placeholder="{{'SIGNIN.PASS' | translate }}" [(ngModel)]="password" required >
                        </mat-form-field>

                        <!-- Change server -->
                        <mat-form-field class="w-100" *ngIf="changeServer > 5">
                            <mat-icon matPrefix class="mr-2">settings_remote</mat-icon>
                            <input matInput #host="ngModel" type="text" name="host" placeholder="{{'SIGNIN.CHANGE_SERVER' | translate }}" [(ngModel)]="service.V.config.host"  >
                        </mat-form-field>

                        <!-- Sign in button -->
                        <button mat-raised-button color="primary" type="submit" class="w-100 m-0" [disabled]="email.invalid || pass.invalid">{{ 'SIGNIN.LOGIN' | translate }}</button>
                        
                        <div class="row">
                            <div class="col-6">
                                <button mat-button color="primary" *ngIf="!service?.vasatInstance?.hide_signup" type="button" (click)="openRegisterDialog()" class="m-0 mt-2 p-0">{{ 'SIGNIN.REGISTER' | translate }}</button>
                       
                            </div>
                            <div class="col-6 text-right">
                                <button mat-button color="primary" type="button" (click)="openForgotDialog()" class="m-0 mt-2 p-0 mr-0 ">{{ 'SIGNIN.FORGOT' | translate }}</button>
                            </div>
                        </div>
                        
                    </form>
                    <ng-container *ngIf="showGoogle || showFacebook">
                        <!-- Sign in 'or' options -->
                        <div class="row">
                            <div class="col-5"><hr/></div>
                            <div class="col-2"><h5 translate class="h5-center align-text-center m-0" style="height: 30px;line-height: 30px;">GENERIC.OR</h5></div>
                            <div class="col-5"><hr/></div>
                        </div>

                        <!-- Social media login -->
                        <div class="row d-flex justify-content-center  m-0">

                            <!-- Google login -->
                            <button mat-mini-fab class="social-btn google" (click)="oauth('google')" *ngIf="showGoogle">
                                <fa-icon [icon]="['fab', 'google']" size="2x"></fa-icon>
                            </button>
                            <span style="width: 16px" *ngIf="showGoogle && showFacebook"></span>

                            <!-- Facebook login-->
                            <button mat-mini-fab class="social-btn facebook" (click)="oauth('facebook')" *ngIf="showFacebook">
                                <fa-icon [icon]="['fab', 'facebook-f']" size="2x"></fa-icon>
                            </button>
                        </div>
                    </ng-container>
                    <!------------------------->
                    <!-- <button mat-button color="primary" (click)="navigateToRoute(routes.AUTH_SIGNUP)" class="w-100 m-0 mt-2">{{ 'SIGNIN.REGISTER' | translate }}</button> -->
                </div>

             <!-- Version number -->
            <div class="text-right" style="color:#AAA"><small>v {{ service.vasatInstance?.app_version }}</small></div>
        </div>
    </div>

</div>
<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>
